module.exports = __webpack_public_path__ + "static/media/banner_bg_2.c6e7c59b.png";